import { Pipe, PipeTransform } from '@angular/core';

import { lowerCase } from '../utils/lodash-utils';

/**
 * A pipe that splits camelCase, kebab-case, or snake_case strings into space-separated words.
 * It leverages the existing lowerCase utility from shared-util-lib.
 *
 * @usage
 * {{ 'startTime' | caseSplit | titlecase }} // Output: "Start Time"
 */
@Pipe({
  name: 'caseSplit',
  standalone: false,
})
export class CaseSplitPipe implements PipeTransform {
  transform(value: any): string {
    if (typeof value !== 'string') {
      return value;
    }
    return lowerCase(value);
  }
}
